const Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
    initialize: function({model, modelProperty}) {
      if (!model) {
        model = this.view.model;
      }
      if (_.isFunction(model)) {
        model = model({ view: this.view });
      }
      if (_.isFunction(modelProperty)) {
        modelProperty = modelProperty({ view: this.view, model: model });
      }
      this.model = model;
      this.modelProperty = modelProperty;
      this.listenTo(this.view, 'render', this.addCustomTemplateBindings);
    },
    getProperties: ($el) => {
      return _.map($el.find('[data-propertyName]'), (element) => element.attr('data-propertyName'));
    },
    addCustomTemplateBindings: function(){
      let view = this.view;
      let model = this.model;
      let properties = this.getProperties(view.$el);
      let propertyPrefix = this.modelProperty ?
        `${this.modelProperty}.` :
        '';
      _.forEach(properties, (property) => {
        view.addBinding(model,
          `[data-propertyName=${property}]`,
          { observe: `${propertyPrefix}${property}` });
      });
    }
});
